module.exports = __webpack_public_path__ + "static/media/timesheet_download.51ebc37e.svg";